<template>
  <div class="nzmActEntry">
    <img :src="config.img" alt class="main_img"  @click.prevent="click_item" />

    <div class="row">
      <div class="title">{{config.title}}</div>
      <div class="date">{{config.date}}</div>
    </div>

    <div class="row">
      <div class="sub_title">{{config.subtitle}}</div>
      <div class="address">{{config.address}}</div>
    </div>

    <div v-if="config.button_text" class="button" @click.prevent="click_item">{{config.button_text}}</div>
  </div>
</template>
<script>
import click_handler from "../../tools/mgtv/click";
import { openLink } from "../../tools/mgtv/link";

export default {
  name: "NzmActEntry",
  components: {},
  props: {
    info: {
      type: Object,
      default: () => {
        return {
          // act_name: "vip_club",
          // act_name_chn: "活动入口",
          // comp_type: "NzmActEntry",
          // wrap_style: {
          //   paddingTop: "0px"
          // },
          // title: {
          //   show: true,
          //   title: "我是NzmActEntry的标题",
          //   icon: "https://via.placeholder.com/64x32?text=ICON",
          //   more_url: "https://www.mgtv.com"
          // },
          // img: "https://via.placeholder.com/710x150?text=ACT_ENTRY",
          // title: "郑爽十周年生日会",
          // subtitle: "郑爽生日会|会员福利攻略",
          // date: "2019/09/30",
          // address: "上海",
          // button_text: "立即报名",
          // button_url: "https://www.mgtv.com",
          // vip_level: 0
        };
      }
    }
  },
  data: function() {
    return {};
  },
  methods: {
    click_item() {
      click_handler(
        `${this.info.act_name_chn}-点击`,
        () => {
          setTimeout(() => {
            openLink(this.config.button_url);
          }, 200);
        },
        {
          need_vip_level: this.config.vip_level
        }
      );
    }
  },
  mounted() {},

  computed: {
    config: function() {
      return this.info.config;
    }
  }
};
</script>


<style lang="stylus" >
  @import "../../share/mixins.styl";
  .nzmActEntry
    position relative
    width 7.1rem
    margin 0 auto
    padding-bottom .24rem
    .main_img
      width 7.1rem
      height 1.5rem
      display block
    .row
      display flex
      justify-content space-between
      align-items center  
      margin-top .1rem
    .title
      font-size .26rem
      font-weight  bold
      width 4.2rem
      ellipsis()
      
    .sub_title
      font-size .24rem
      color #969696  
      max-width 6rem
      ellipsis()
    .date 
      font-size .24rem
      color #969696    
    .address
      background #F2F2F2
      font-size .24rem
      color #969696
      padding 0.04rem .08rem
    .button
      background-image: linear-gradient(90deg, #FEDD9F 0%, #FFC562 100%);
      box-shadow: 0 3px 3px 0 rgba(252,216,151,0.34);
      border-radius: 17px;
      font-size: .28rem;
      color: #CB8723;
      width 3rem
      height .68rem
      display block
      margin .1rem auto 
      line-height @height
      text-align center

           
</style>
